import { UNIFIED_HELP_CENTER_BASE_PATH } from 'view/common/constants';
import { getRelativeBasePath } from 'util/history';

export const isAdvancedHelpCenter = () => {
    return getRelativeBasePath().startsWith('/helpcenter') && !isUnifiedHelpHelpCenter();
};

export const isUnifiedHelpHelpCenter = () => {
    return getRelativeBasePath() === UNIFIED_HELP_CENTER_BASE_PATH;
};

export const getSlugForAdvancedHCFromArticleView = (url: string) => {
    const pattern = /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};
